import React from 'react'



export default function About() {
  return <>

    <section id="about" className='py-5 about-section'>

    
    <div  className="container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h4 className='text-muted  intro-header py-2'>Introduction</h4>
          <h1 className='header-one'>Overview.</h1>
          <h5 className=' header-two pt-2'>Welcome to our premier VPS seller website, where we specialize in providing top-quality Virtual Private Servers tailored to meet your specific hosting needs. At LuminaryCloud, we understand the importance of a reliable and high-performance hosting solution for your online endeavors.</h5>

        </div>
      </div>

    </div>
  
    </section>
  
  </>
}
 